const initialState = {
  data: [],
  total: 1,
  params: {}
}

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'SET_DATA':
      return {
        ...state,
        data: action.data
      }
    case 'DELETE_INVOICE':
      return { ...state }
    default:
      return { ...state }
  }
}
export default invoiceReducer
